module.exports = __webpack_public_path__ + "media/images/code_2-7ff56f094043757562da8a6776e5a406.png";